import { useState } from "react";
import { Check } from "lucide-react";
import { drawerInput } from "../Drawer";
import { UndoToast } from "../crm/ui";

// Small helpers shared by the settings screens (design: screens/settings/SettingsPages.tsx).

export const initials = (name = "") => name.split(/\s+/).filter(Boolean).map((part) => part.replace(/^Dr\.\s*/i, "")[0] || "").join("").slice(0, 2).toUpperCase();
export const cn = (...classes) => classes.filter(Boolean).join(" ");

/** Toast state + element. `setToast({ message, undo? })`. */
export function useToast() {
  const [toast, setToast] = useState(null);
  return { toast, setToast, Toast: toast ? <UndoToast message={toast.message} onUndo={toast.undo} onDone={() => setToast(null)} /> : null };
}

/** Items are strings, or { value, label }. Value is an array of item values. */
export function CheckList({ items, value, onChange }) {
  const opts = items.map((item) => (typeof item === "string" ? { value: item, label: item } : item));
  return <div className="flex flex-col gap-2">{opts.map((item) => <label key={item.value} className="flex items-center gap-2 text-small"><input type="checkbox" checked={value.includes(item.value)} onChange={(e) => onChange(e.target.checked ? [...value, item.value] : value.filter((x) => x !== item.value))} className="accent-ink" />{item.label}</label>)}</div>;
}

export const COLOR_CHOICES = ["#82add4", "#ddfd2c", "#000000", "#2f5f8a", "#5f5f5a", "#f0f0ed", "#ffffff"];
export function ColorChoices({ value, onChange }) {
  return <div className="flex flex-wrap items-center gap-2">{COLOR_CHOICES.map((color) => <button key={color} type="button" aria-label={`Choose ${color}`} aria-pressed={value === color} onClick={() => onChange(color)} className={cn("flex h-9 w-9 items-center justify-center rounded-full border border-line ring-1 ring-ink/20", value === color && "ring-2 ring-ink ring-offset-2")} style={{ backgroundColor: color }}>{value === color && <Check size={15} className={color === "#000000" ? "text-paper" : "text-ink"} />}</button>)}<input aria-label="Brand colour hex" value={value} onChange={(e) => onChange(e.target.value)} className={`${drawerInput} h-9 w-28! font-mono text-caption`} /></div>;
}

/** "Sunrise Dental, FC Road" → "FC Road" when a facility name repeats the clinic name. */
export const shortFacility = (name = "", orgName = "") => (orgName && name.startsWith(`${orgName}, `) ? name.slice(orgName.length + 2) : name);
